import { SvgIcon } from '@material-ui/core'
import React from 'react'

export const DisplayFormikState = (props) => {
  return (
    <div style={{
      position: 'sticky',
      top: 75.67,
      zIndex: 10
    }}>
      <pre
        style={{
          background: '#f6f8fa',
          padding: '.5rem',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          margin: 0
        }}
      >
      <strong>props</strong> ={' '}
        {JSON.stringify(props, null, 2)}
    </pre>
    </div>
  )
}

export const ExcelIcon = (props) => {
  return (
    <SvgIcon fill="none" viewBox="0 0 96 96" strokeMiterlimit="10" strokeWidth="2" {...props}>
      <path stroke="#979593"
            d="M67.1716,7H27c-1.1046,0-2,0.8954-2,2v78 c0,1.1046,0.8954,2,2,2h58c1.1046,0,2-0.8954,2-2V26.8284c0-0.5304-0.2107-1.0391-0.5858-1.4142L68.5858,7.5858 C68.2107,7.2107,67.702,7,67.1716,7z"/>
      <path fill="none" stroke="#979593" d="M67,7v18c0,1.1046,0.8954,2,2,2h18"/>
      <path fill="#C8C6C4"
            d="M51 61H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 60.5523 51.5523 61 51 61zM51 55H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 54.5523 51.5523 55 51 55zM51 49H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 48.5523 51.5523 49 51 49zM51 43H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 42.5523 51.5523 43 51 43zM51 67H41v-2h10c.5523 0 1 .4477 1 1l0 0C52 66.5523 51.5523 67 51 67zM79 61H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 60.5523 79.5523 61 79 61zM79 67H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 66.5523 79.5523 67 79 67zM79 55H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 54.5523 79.5523 55 79 55zM79 49H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 48.5523 79.5523 49 79 49zM79 43H69c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C80 42.5523 79.5523 43 79 43zM65 61H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 60.5523 65.5523 61 65 61zM65 67H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 66.5523 65.5523 67 65 67zM65 55H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 54.5523 65.5523 55 65 55zM65 49H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 48.5523 65.5523 49 65 49zM65 43H55c-.5523 0-1-.4477-1-1l0 0c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1l0 0C66 42.5523 65.5523 43 65 43z"/>
      <path fill="#107C41"
            d="M12,74h32c2.2091,0,4-1.7909,4-4V38c0-2.2091-1.7909-4-4-4H12c-2.2091,0-4,1.7909-4,4v32 C8,72.2091,9.7909,74,12,74z"/>
      <path fill="#fff"
        d="M16.9492,66l7.8848-12.0337L17.6123,42h5.8115l3.9424,7.6486c0.3623,0.7252,0.6113,1.2668,0.7471,1.6236 h0.0508c0.2617-0.58,0.5332-1.1436,0.8164-1.69L33.1943,42h5.335l-7.4082,11.9L38.7168,66H33.041l-4.5537-8.4017 c-0.1924-0.3116-0.374-0.6858-0.5439-1.1215H27.876c-0.0791,0.2684-0.2549,0.631-0.5264,1.0878L22.6592,66H16.9492z"/>
    </SvgIcon>
  )
}

/**
 * Log function works only in development and removed in production
 * @param text
 * @param args
 */
export const log = (text, ...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`%c${text}`, 'color:#fff;background-color:#3c3c3c;font-size:18px;display:block;padding:0 20px;', ...args)
  }
}

/** Method to Filter the Empty params before send the API Request.
 *
 * @param data
 * @returns {{}}
 */
export const filterData = (data) => {
  let newData = {}
  Object.keys(data).forEach((key => {
    const isString = typeof data[key] === 'string' && data[key].length
    const isArray = Array.isArray(data[key]) && data[key].length
    const isNumber = Number.isInteger(data[key])
    const isBoolean = typeof data[key] === 'boolean' && data[key] === !!data[key]
    if (isString || isArray || isNumber || isBoolean) {
      newData[key] = data[key]
    }
  }))
  return newData
}

export const parseLocaleNumber = (num) => {
  // Detect the user's locale decimal separator:
  let decimalSeparator = (1.1).toLocaleString().substring(1, 2)
  // Detect the user's locale thousand separator:
  let thousandSeparator = (1000).toLocaleString().substring(1, 2)
  // In case there are locales that don't use a thousand separator
  if (thousandSeparator.match(/\d/))
    thousandSeparator = ''

  num = num.replace(thousandSeparator, '').replace(decimalSeparator, '.')

  return parseFloat(num)
}

export const filterTags = (tags) => {
  let newTags = []
  tags.forEach((value, index) => {
    if (!!value.tag) {
      newTags.push(value)
    }
  })
  return newTags
}
export const filterCategories = (categories) => {
  let newCategories = []
  categories.forEach((value, index) => {
    if (!!value.id) {
      newCategories.push(value)
    }
  })
  return newCategories
}

export const randomKey = Math.random().toString(36).substr(2, 9)

export const isEmpty = (object) => {
  return !Object.getOwnPropertySymbols(object).length && !Object.getOwnPropertyNames(object).length
}

/**
 * Get priceable_type based on payable_type for promocode payables
 * @param {string} payableType - The payable type (App\\Models\\Service or App\\Models\\Plan)
 * @returns {string} - The corresponding priceable type
 */
export const getPriceableType = (payableType) => {
  if (payableType === 'App\\Models\\Service') {
    return 'App\\Models\\ServicePrice'
  } else if (payableType === 'App\\Models\\Plan') {
    return 'App\\Models\\PlanPrice'
  }
  return ''
}
